import { useIsElementVisible } from '#app/hooks/useIsElementVisible.js';
import { useEffect, useRef } from 'react';

export const useOnElementViewed = <T extends HTMLElement = HTMLElement>(
  onViewed: () => void,
  intersectionalObserverOptions?: IntersectionObserverInit,
) => {
  const callbackWasTriggered = useRef(false);
  const [observableRef, isVisible] = useIsElementVisible<T>(
    intersectionalObserverOptions,
  );

  useEffect(() => {
    if (isVisible && !callbackWasTriggered.current) {
      onViewed();
      callbackWasTriggered.current = true;
    }
  }, [callbackWasTriggered, isVisible, onViewed]);

  return observableRef;
};
